_fragile_config = {
  merchant_name: "headphones",
  base_embed_url: "https://merchant-embed.fragile.co",
  base_api_url: "https://new.fragileapi.com",
  base_checkout_url: "https://checkout.fragile.co",
};

function createModalWithIframe(fragileProductId) {
  var modalContainer = document.createElement("div");
  modalContainer.className = "fragile-sandbox-container";
  modalContainer.style.cssText =
    "overflow: hidden; position: fixed; inset: 0px; z-index: 999999;";

  var iframeContainer = document.createElement("div");
  iframeContainer.className = "fragile-iframe-container";
  iframeContainer.style.cssText =
    "height: 100%; width: 100%; margin: auto; background-color: rgba(0,0,0,.72); border: 0px none;";

  var iframeBackground = document.createElement("div");
  iframeBackground.className = "fragile-iframe-background";
  iframeBackground.style.cssText =
    "height: 650px; max-width: 520px; margin: auto; position: relative; top: 30px; background-color: white; border-radius: 8px";

  var iframe = document.createElement("iframe");
  iframe.src = `${_fragile_config.base_embed_url}?merchant=${_fragile_config.merchant_name}&product=${fragileProductId}`;
  iframe.style.cssText =
    "overflow: hidden; width: 100%; height: 100%; border: 0px none;";

  iframeBackground.appendChild(iframe);
  iframeContainer.appendChild(iframeBackground);
  modalContainer.appendChild(iframeContainer);

  document.body.appendChild(modalContainer);
  document.body.style.overflow = "hidden";

  window.addEventListener(
    "message",
    function (event) {
      if (event.data === "FRAGILE_MODAL_CLOSE") {
        var modal = document.querySelector(".fragile-sandbox-container");
        if (modal) {
          document.body.removeChild(modal);
          document.body.style.overflow = "";
        }
      }
    },
    false
  );
}

async function loadFragilePrice(fragileProductId) {
  const response = await fetch(
    `${_fragile_config.base_api_url}/products/public/${fragileProductId}`,
    {
      headers: {
        "X-Fragile-Tenant": _fragile_config.merchant_name,
      },
    }
  );

  const data = await response.json();

  return data.data.price.amount;
}

window.updateFragileElements = async function (fragileProductId) {
  var modalTriggers = document.querySelectorAll("[data-fragile-modal-toggle]");

  modalTriggers.forEach(async function (elt) {
    elt.addEventListener("click", function (event) {
      event.preventDefault();
      createModalWithIframe(fragileProductId);
    });
  });

  const price = await fragilePrice;
  var subscriptionPrices = document.querySelectorAll("[data-fragile-price]");

  subscriptionPrices.forEach(async function (elt) {
    elt.innerHTML = price / 100;
  });

  var checkoutLinks = document.querySelectorAll("[data-fragile-url]");

  checkoutLinks.forEach(async function (elt) {
    var checkoutUrl = `${_fragile_config.base_checkout_url}/${_fragile_config.merchant_name}/subscribe?collectionId=${fragileProductId}`;
    elt.setAttribute("href", checkoutUrl);
  });
}

var initialProductId = document
  .querySelector("[data-fragile-product-id]")
  .getAttribute("data-fragile-product-id");

if (initialProductId) {
  var fragilePrice = loadFragilePrice(initialProductId);

  window.addEventListener("DOMContentLoaded", async function () {
    window.updateFragileElements(initialProductId);
  });
}
